import type { ThemeTokens } from './types';
import { tealLight } from './definitions/tealLight';
import { tealDark } from './definitions/tealDark';
import { blueLight } from './definitions/blueLight';
import { blueDark } from './definitions/blueDark';

export type Brand = 'teal' | 'blue';
export type ColorMode = 'light' | 'dark';
export type FontSet = 'inter' | 'system';
export type ThemeId = `${Brand}-${ColorMode}`;

const SYSTEM_FONT_SANS = "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
const SYSTEM_FONT_MONO = "ui-monospace, 'Cascadia Code', 'Courier New', monospace";

export const THEMES: Record<ThemeId, ThemeTokens> = {
  'teal-light': tealLight,
  'teal-dark':  tealDark,
  'blue-light': blueLight,
  'blue-dark':  blueDark,
};

export function buildThemeId(brand: Brand, colorMode: ColorMode): ThemeId {
  return `${brand}-${colorMode}`;
}

export function getTheme(id: ThemeId): ThemeTokens {
  return THEMES[id];
}

/**
 * Returns a new ThemeTokens with font fields overridden for the requested
 * font set. 'inter' is a no-op (fonts already set). 'system' strips Google
 * Fonts and substitutes OS font stacks.
 */
export function applyFontSet(base: ThemeTokens, fontSet: FontSet): ThemeTokens {
  if (fontSet === 'inter') return base;
  return {
    ...base,
    fontSans:       SYSTEM_FONT_SANS,
    fontMono:       SYSTEM_FONT_MONO,
    fontDisplay:    SYSTEM_FONT_SANS,
    googleFontsUrl: null,
  };
}
